export default __webpack_public_path__ + "static/media/Sandra-Una-Boakye.e4f46479.png";